<template>
  <div class="container">
    <div class="title">
      <p class="words">近7日利用率(%)</p>
    </div>
    <div class="tips flex">
      <div class="flex-row">
        <div style="width:12px;height:12px;background: linear-gradient(360deg, #15FF87 0%, #30BC74 100%);border-radius: 2px;margin-right: 5px;"></div>
        <div>时间利用率</div> 
      </div>
      <div class="flex-row">
        <div style="width:12px;height:12px;background: linear-gradient(360deg, #72B4FA 0%, #3E7DF2 100%);border-radius: 2px;margin-right: 5px;"></div>
        <div>功率利用率</div>
      </div>
    </div>
    <div id="chart6" ref="main6" style="width: 100%; height: 160px"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      echartArea6: null,
      xData: [],
      yData: [],
      yPowerData:[]
    };
  },
  props:{
    level:'',
    regionId:''
  },
  mounted() {
    this.initChart();
    // this.getSouceData();
  },
  methods: {
    initChart() {
      this.echartArea6 = this.$echarts.init(this.$refs.main6);
      this.getSouceData();
    },
    getSouceData(){
      this.$http({
        url: this.$http.adornUrl("/admin/api/busi/ev/stat/rate"),
        method: "get",
        params: this.$http.adornParams({
          deviceType: 1,
          level:this.level,
          regionId: this.regionId,
        }),
      }).then(({ data }) => {
        console.log(data,'汽车使用率')
        if (data.code == 0) {
          this.xData = data.data.dayList;
          this.yData = data.data.timeRateList;
          this.yPowerData = data.data.powerRateList;
          this.updatedChart();
        }
      });
    },
    updatedChart() {
      var XName = this.xData;
      var YbarData = this.yData
      var YlineData = this.yPowerData
      const option = {
        grid: {
          left: "1%",
          right: "1%",
          bottom: "10%",
          top: "7%",
          height: "85%",
          containLabel: true,
          z: 22,
        },
        xAxis: {
          type: "category",
          gridIndex: 0,
          data: XName,
          axisTick: {
            show:true,
          },
          axisLine: {
            show:true,
            lineStyle: {
              color: "#fff",
            },
          },
          axisLabel: {
            show: true,
            color: "#fff",
            fontSize: 10,
            formatter:"{value} "+'日'
          },
        },
        yAxis: {
          name:'元',
          type: "value",
          gridIndex: 0,
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          min: 0,
          max: 100,
          xisLabel: {
            color: "rgb(170,170,170)",
            formatter: "{value} ",
          },
          splitLine: {
            lineStyle: {
              type: "solid",
              color: "rgba(135,140,147,0.8)",
            },
          },
          axisLabel:{
            formatter:"{value} "+'%',
            textStyle:{
              color: "#fff",
            }
          },
          axisLine:{
            show:true,
            lineStyle: {
              color: "#fff",
            },
          }
        },
        series: [
          {
            name: "合格率",
            type: "bar",
            barWidth: "20%",
            itemStyle: {
              color: "#329ffa",
              barBorderRadius:[10,10,0,0]
            },
            emphasis: {
              itemStyle: {
                color: "#FA6400",
              },
              label: {
                show: true,
              },
            },
            data: YbarData,
            zlevel: 11,
          },
          {
            name: "时间使用率",
            type: "line",
            data:YbarData,
            symbol: "emptyCircle",
            symbolSize: 6,
            showSymbol: true,
            itemStyle:{
              normal:{
                color:"rgba(21, 255, 135, 1)"
              }
            },
            lineStyle:{
              normal:{
                with:5,
                color:"rgba(21, 255, 135, 1)"
              }
            }
          }
        ],
      };

      this.echartArea6.setOption(option);
      // let _t = -1;

      // setInterval(() => {
      //   this.echartArea6.dispatchAction({
      //     type: "downplay",
      //     seriesIndex: 0,
      //     dataIndex: _t % 16,
      //   });
      //   _t++;
      //   this.echartArea6.dispatchAction({
      //     type: "highlight",
      //     seriesIndex: 0,
      //     dataIndex: _t % 16,
      //   });
      // }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 10px;
  position: relative;
  .tips{
    position: absolute;
    right: 20px;
    top:15px;
    display: flex;
    .flex-row{
      // height: 20px;
      line-height: 20px;
      margin-left: 10px;
      color: #fff;
      font-size: 10px;
      display: flex;
      align-items: center;
    }
  }
}
.title {
  width: 140px;
  height: 28px;
  line-height: 28px;
  background-image: url("../../assets/title-bg.png");
  background-size: 100% 100%;
  margin-bottom: 10px;
  margin-left: 10px;
  color: #00ecfc;
  position: relative;
  .words {
    position: absolute;
    left: 20px;
    top: 0px;
    width: 280px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/car-system/option6.vue